import { connect } from "react-redux";
import { getSpSetting } from "store/selector/sp.selector";
import Participants from "./Participants";

const mapStateToProps = (state) => ({
  settings: getSpSetting(state),
});

export default connect(mapStateToProps)(Participants);
